export default __webpack_public_path__ + "static/media/19.e93ea517.webp";